// extracted by mini-css-extract-plugin
export default {"code":"J_ch"};